import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { COUNTRIES } from '@wareclouds/frontend-common';
import { FALLBACKLNG } from '../../config/consts/commons';
import env from '../../config/env';

const DEFAULT_LNG = FALLBACKLNG[COUNTRIES.CL];

const options = {
  loadPath: '/locales/{{lng}}/{{ns}}.json',
  addPath: '/locales/add/{{lng}}/{{ns}}',
  allowMultiLoading: false,
  crossDomain: false,
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: ['system', 'description'],
    defaultNS: 'system',
    fallbackLng: FALLBACKLNG[env.CONTEXT] || DEFAULT_LNG,
    lng: FALLBACKLNG[env.CONTEXT] || DEFAULT_LNG,
    backend: options,
  });

i18n.services.formatter.add('capitalize', (value, lng, options) => {
  return value[0].toLowerCase() + value.substring(1);
});

export default i18n;
